/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getServiceMessage} from '../api'

 export const useQueryGetServiceMessage = createReactQueryHook('getServiceMessage', getServiceMessage)
